import { MobileAppService } from '../../mobile/services/MobileAppService';
import { ServerSettingsUnauthenticated } from '../../settings/services/ServerSettingsUnauthenticated';

export function isPhoneSizedScreen() {
  return Math.min(screen.width, screen.height) <= ServerSettingsUnauthenticated.dsdPhoneSize();
}

export function hideLaunchEditOnMobile() {
  return isPhoneSizedScreen() || MobileAppService.isUserProbablyOnMobile();
}
